import {Grid} from "@mui/material";
import ImageWithCenteredText from "../../ImageWithCenteredText";
import React from "react";
import {useLanguage} from "../../../LanguageContext";

const ImagesSection = ({imageList}) => {
    const {t} = useLanguage();

    return (
        <Grid container>
            {imageList.map((item, index) => (
                <Grid item xs={12} sm={6} md={6} key={index}>
                    <ImageWithCenteredText imageUrl={item.imageUrl} text={t(item.text)}/>
                </Grid>
            ))}
        </Grid>
    );
}

export default ImagesSection;
